import React from 'react'
import { createFileRoute } from '@tanstack/react-router'

import FoodRestrictionsIndex from '@/features/food-restrictions/FoodRestrictionsIndex'

export const Route = createFileRoute('/food-restrictions/')({
  component: FoodRestrictionsComponent,
})

function FoodRestrictionsComponent() {
  return <FoodRestrictionsIndex />
}
